import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: PhenologicalStateCreateInput!
  ) {
    createOnePhenologicalState(data: $data) {
      name
    }
  }
`

export default () => (
  useMutation(MUTATION, `Estado Fenológico criado`, mutationTypes.CREATE)
)
